const smbLpSectionNavigationEditableDefaults = {
  showButtons: true,
}

export default smbLpSectionNavigationEditableDefaults;
